import { useClientConfigProvider } from "@/app/config/client-config-provider";
import useDebounce from "@/app/utility/debounce";
import { BenefitGroupConfig, useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import SearchItemPopular from "./search-item-popular";
import SearchItemRecent from "./search-item-recent";

import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import StringConstants from "@/app/constants/string-contants";
import { useMixPanel } from "@/app/context/mixPanelContext";
import RedirectToCard from "@/app/utility/redirect";
import moment from "moment";
import { useRouter } from "next/navigation";
import SpinnerLoaderNew from "../spinner-loader-new";
import CommonUtils from "@/app/utility/common";
import { useTranslation } from "react-i18next";

export default function SearchInput() {
  const { config, getImagePath } = useClientConfigProvider();
  const [searchText, setSearchText] = useState<string>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchedItemList, setSearchedItemList] = useState<any[]>([]);
  const [searchedItemConfigList, setSearchedItemConfigList] = useState<
    BenefitGroupConfig[]
  >([]);
  const [recentSearchList, setRecentSearchList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSearchNotFound, setIsSearchNotFound] = useState<boolean>(false);
  const [userQuotaData, setUserQuotaData] = useState<any>([]);
  /*  const [popularList, setPopularList] = useState<any[]>([]); */
  const debouncedSearch = useDebounce(searchText, 400);
  const context = useAppContext();
  const { trackEvent } = useMixPanel();
  const {
    state: { isMobile, benefits, selectedMembership, user },
    instances: { apiRepository },
  } = context;

  const router = useRouter();
  const { t } = useTranslation();

  const getBenefitConfigInfoFromList = (configId: number) => {
    let configObj: BenefitGroupConfig | undefined;
    searchedItemConfigList?.forEach((config: BenefitGroupConfig) => {
      if (config._id == configId) {
        configObj = config;
      }
    });
    console.log("configobj", configObj);

    return configObj;
  };

  useEffect(() => {
    if (benefits?.data) {
      fetchUserQuota();
    }
  }, [benefits?.data]);

  useEffect(() => {
    if (isFocused && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isFocused]);

  function fetchUserQuota() {
    apiRepository
      ?.getUserQuota({
        benefitConfigId:
          benefits?.data?.benefit_group_configs
            ?.map((configData: any, index: any) => configData?._id)
            .toString() ?? "",
        membershipId: selectedMembership?.data?.membership_id ?? "",
      })
      .then((v: any) => {
        const data = v.data.results;
        setUserQuotaData(data);
      })
      .catch((e: any) => {
        /*  if (e?.response?.data?.message) {
          ToastUtils.showErrorToast(e?.response?.data?.message);
        } else {

        } */
      });
  }

  useEffect(() => {
    if (user?.data) {
      console.log("userdatasearchdebounced", user?.data, debouncedSearch);
      if (debouncedSearch.length > 0) {
        setIsLoading(true);
        setIsSearchNotFound(false);
        setTimeout(() => {
          apiRepository
            ?.getSearchBenefits({
              pattern: debouncedSearch,
              membershipId: selectedMembership?.data?.membership_id ?? "",
            })
            .then((v) => {
              setIsLoading(false);
              const data = v.data.services;
              const configs = v.data.benefit_group_configs;
              let benefits = configs;

              let benefitsList = [...benefits];
              console.log("bookinghistory from header");
              apiRepository
                ?.fetchBookingsHistory({
                  pageSize: 1,
                  pageIndex: 0,
                  membershipIds: [
                    selectedMembership?.data?.membership_id ?? "",
                  ],
                })
                .then((r) => {
                  if (r?.data?.result?.length > 0) {
                    let newBenefits = benefitsList?.map((item: any) => {
                      if (
                        item?._id !==
                        r?.data?.result?.[0]?.benefit_group_config_id
                      )
                        return {
                          ...item,
                          nonredeemable: true,
                        };
                      else {
                        return item;
                      }
                    });
                    setSearchedItemConfigList(newBenefits);
                  } else {
                    setSearchedItemConfigList(benefits);
                  }
                });

              setSearchedItemList(
                data?.filter(
                  (item: any) =>
                    !config?.header?.filterServiceBy ||
                    item?.service_type === config?.header?.filterServiceBy
                )
              );
              // setSearchedItemConfigList(configs);
              if ((data?.length ?? 0) == 0) {
                setIsSearchNotFound(true);
              }
            })
            .catch((e) => {
              setIsSearchNotFound(true);
              setSearchedItemList([]);
              setIsLoading(false);
            });
        }, 500);
      } else {
        getRecentHistory();
      }
    }
  }, [debouncedSearch, user?.data?.membershipId]);

  function getRecentHistory() {
    apiRepository
      ?.getSearchHistory()
      .then((v) => {
        const data = v.data.result;
        setRecentSearchList(data);
      })
      .catch((e) => {});
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        popupRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
      }
    }

    // Add event listener on mount
    document.addEventListener("mousedown", handleClickOutside);

    // Remove event listener on cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // function handleSearchRedirect({
  //   searchType,
  //   config,
  //   searchItem,
  //   params,
  //   router,
  // }: {
  //   searchType: string;
  //   config: any;
  //   searchItem: any;
  //   params: string;
  //   router: any;
  // }) {
  //   if (searchType === `BENEFIT`) {
  //     switch (config?.booking_type) {
  //       case `DELAYED`:
  //       case `CUSTOM_DELAYED`:
  //         console.log("booking-typei", config?.booking_type, searchType);
  //         router.push(`${AppRoutes.delayedBookingDetails}?${params}`);
  //         break;

  //       case `UNIQUE_COUPON`:
  //         router.push(`${AppRoutes.benefitDetails}?${params}`);
  //         break;

  //       case `LISTING_V2`:
  //       case `VALET_BOOKING`:
  //       case `QR_BOOKING`:
  //         console.log("booking-typep", config?.booking_type, searchType);
  //         window.open(
  //           `${AppRoutes.listingDetail}?benefitConfigId=${config?._id}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`,
  //           "_self"
  //         );
  //         break;

  //       default:
  //         break;
  //     }
  //   } else if (searchType === `OUTLET`) {
  //     window.open(
  //       `${AppRoutes.facilityDetails}?benefitConfigId=${config?._id}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`,
  //       "_self"
  //     );
  //   }
  // }

  return (
    <div>
      {/* Background Blur Effect */}
      <div className={isFocused ? "blur-background" : ""} />

      {/* Search Input */}
      <div className="search-container">
        <div ref={containerRef}>
          <div
            className={`${
              isFocused ? "search-header-banner-search-animation " : ""
            } search-header-banner-search d-flex align-items-center d-none d-lg-flex`}
          >
            <span>
              <Image
                src={"/common-images/search.png"}
                alt="Search Icon"
                width={20}
                height={20}
                className="search-icon-size"
              />
            </span>
            <input
              ref={inputRef}
              onClick={() => {
                setIsFocused(true);
                trackEvent(EventLabels.CTA_Search, { screen: "Search" });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  (e.target as HTMLInputElement).blur();
                }
              }}
              className={`${
                isFocused ? "search_input_animation" : ""
              } search_input`}
              type="text"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              placeholder={`${config?.header?.searchPlaceholderText ?? ``}`}
              /* onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)} */
            />
          </div>
          <div className="d-block d-lg-none" onClick={() => setIsFocused(true)}>
            <span>
              <Image
                src={getImagePath("search_anim.gif")}
                alt=""
                width={34}
                height={34}
                className="header-search-image c-pointer"
              />
            </span>
          </div>
        </div>

        {/* Search Popup */}
        {isFocused && (
          <div className="search-popup" ref={popupRef}>
            <div>
              <div
                className={`search-header-banner-search-animation 
                  search-header-banner-search d-flex align-items-center d-flex d-lg-none`}
              >
                <span>
                  <Image
                    src={"/common-images/search.png"}
                    alt="Search Icon"
                    width={20}
                    height={20}
                  />
                </span>
                <input
                  ref={inputRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      (e.target as HTMLInputElement).blur();
                    }
                  }}
                  className={`search_input_animation
                   search_input`}
                  type="text"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  placeholder={"Search for Brands and More"}
                  /* onFocus={() => setIsFocused(true)}
             onBlur={() => setIsFocused(false)} */
                />
              </div>
            </div>
            <div className="search-scroll-container">
              {searchText.length == 0 &&
                (recentSearchList?.length ?? 0) > 0 && (
                  <div className="search-column">
                    <div className="search-p-heading  font-weight-t-400">
                      {t("header.recentSearch")}
                    </div>
                    {recentSearchList?.map((recentItem, index) => {
                      return (
                        <div key={index}>
                          <SearchItemRecent
                            name={recentItem.Query}
                            onClickItem={() => {
                              trackEvent(EventLabels.ONPG_Recent_Search, {
                                screen: "Search",
                              });
                              setIsSearchNotFound(false);
                              setSearchText(recentItem.Query);
                            }}
                            onCloseClick={() => {
                              apiRepository
                                ?.deleteSearchResult(recentItem.Query)
                                .then(() => {
                                  getRecentHistory();
                                })
                                .catch(() => {});
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}

              {searchText?.length > 0 && (
                <div className="search-column">
                  <div className="search-p-heading  font-weight-t-400">
                    {t("header.searchResult")}
                  </div>
                  {!isLoading && isSearchNotFound && (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      {t("header.noDataFound")}
                    </div>
                  )}

                  {isLoading && (
                    <div style={{ padding: "5px" }}>
                      <div className="text-center">
                        <SpinnerLoaderNew />
                      </div>
                    </div>
                  )}

                  {!isLoading &&
                    searchedItemList?.map((searchItem, index) => {
                      // const quotaObject = userQuotaData?.filter(
                      //   (userQuota: any, index: any) =>
                      //     userQuota?.month === moment().format("MMMM") &&
                      //     userQuota?.benefit_group_config_id ===
                      //       searchItem?.benefit_group_config_id
                      // );

                      // let isAvailableQuota = true;
                      // if (quotaObject?.length === 0) {
                      //   isAvailableQuota = false;
                      // } else if (quotaObject?.length > 1) {
                      //   isAvailableQuota = false;
                      // } else if (quotaObject?.length === 1) {
                      //   isAvailableQuota =
                      //     quotaObject?.[0]?.quota_available > 0;
                      // }

                      const yearlyAvailableQuota = userQuotaData?.filter(
                        (quota: any) =>
                          quota?.benefit_group_config_id?.toString() ===
                            searchItem?.benefit_group_config_id?.toString() &&
                          quota?.unit === `YEAR` &&
                          quota?.quota_available > 0
                      );
                      // const quotaObject = userQuotaData?.filter(
                      //   (userQuota: any, index: any) =>
                      //     userQuota?.month === moment().format("MMMM") &&
                      //     userQuota?.benefit_group_config_id === benefitConfig?._id
                      // );

                      let isAvailableQuota = true;
                      isAvailableQuota = yearlyAvailableQuota?.length > 0;

                      // if (quotaObject?.length === 0) {
                      //   isAvailableQuota = false;
                      // } else if (quotaObject?.length > 1) {
                      //   isAvailableQuota = false;
                      // } else if (quotaObject?.length === 1) {
                      //   isAvailableQuota = quotaObject?.[0]?.quota_available > 0;
                      // }

                      // isAvailableQuota = false;

                      //                       const isAvailableQuota =
                      //                         CommonUtils?.findHaveAvailableQuota(
                      //                           userQuotaData,
                      //                           searchItem?.benefit_group_config_id
                      //                         );

                      const searchType = config?.header?.searchOnBehalfOn;
                      let logo = ``;
                      let name = ``;
                      let offerName = ``;

                      const benefitConfig = getBenefitConfigInfoFromList(
                        searchItem.benefit_group_config_id
                      );

                      console.log("value of searchItem", searchItem);

                      if (searchType === `BENEFIT`) {
                        logo = `${searchItem?.partner?.images?.logo}`;
                        name = `${searchItem?.partner?.name}`;
                        offerName = `${searchItem?.displayName ?? ""}`;
                      } else if (searchType === `OUTLET`) {
                        logo = `${searchItem?.images?.logo}`;
                        name = `${searchItem?.facility?.name}`;
                        offerName = ``;
                      }

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (
                              isAvailableQuota &&
                              // @ts-ignore
                              benefitConfig?.nonredeemable
                            ) {
                              const config = getBenefitConfigInfoFromList(
                                searchItem.benefit_group_config_id
                              );

                              trackEvent(EventLabels.CTA_Redeem, {
                                screen: "Search",
                                source: "Search, Search Result",
                              });

                              let params = new URLSearchParams();
                              params.set(
                                StringConstants.PARAM_BENEFIT_CONFIG_ID,
                                String(config?._id ?? "")
                              );
                              console.log(
                                "booking-types",
                                config?.booking_type,
                                searchType
                              );

                              if (searchType === `BENEFIT`) {
                                if (
                                  config?.booking_type === `DELAYED` ||
                                  config?.booking_type === `CUSTOM_DELAYED`
                                ) {
                                  console.log(
                                    "booking-typei",
                                    config?.booking_type,
                                    searchType
                                  );
                                  router.push(
                                    `${AppRoutes.delayedBookingDetails}?${params}`
                                  );
                                } else if (
                                  config?.booking_type === `UNIQUE_COUPON`
                                ) {
                                  router.push(
                                    `${AppRoutes.benefitDetails}?${params}`
                                  );
                                } else if (
                                  config?.booking_type == "LISTING_V2"
                                ) {
                                  // window.open(
                                  //   `${
                                  //     AppRoutes.listingDetail
                                  //   }?benefitConfigId=${`${config?._id}`}&${
                                  //     StringConstants.PARAM_FACILITY_ID
                                  //   }=${searchItem?.facility?.id}`,
                                  //   "_self"
                                  // );
                                  router.push(
                                    `${AppRoutes.listingDetail}?${params}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`
                                  );
                                } else if (
                                  config?.booking_type == "VALET_BOOKING"
                                ) {
                                  //  router.push(
                                  //     `${
                                  //       AppRoutes.listingDetail
                                  //     }?benefitConfigId=${`${config?._id}`}&${
                                  //       StringConstants.PARAM_FACILITY_ID
                                  //     }=${searchItem?.facility?.id}`,
                                  //     // "_self"
                                  //   );
                                  router.push(
                                    `${AppRoutes.listingDetail}?${params}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`
                                  );
                                } else if (
                                  config?.booking_type == "QR_BOOKING"
                                ) {
                                  console.log(
                                    "booking-typep",
                                    config?.booking_type,
                                    searchType
                                  );
                                  // window.open(
                                  //   `${
                                  //     AppRoutes.listingDetail
                                  //   }?benefitConfigId=${`${config?._id}`}&${
                                  //     StringConstants.PARAM_FACILITY_ID
                                  //   }=${searchItem?.facility?.id}`,
                                  //   "_self"
                                  // );
                                  router.push(
                                    `${AppRoutes.listingDetail}?${params}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`
                                  );
                                } else if (
                                  config?.booking_type == "PADDLE_BOOKING"
                                ) {
                                  console.log(
                                    "booking-typep",
                                    config?.booking_type,
                                    searchType
                                  );
                                  // window.open(
                                  //   `${
                                  //     AppRoutes.listingDetail
                                  //   }?benefitConfigId=${`${config?._id}`}&${
                                  //     StringConstants.PARAM_FACILITY_ID
                                  //   }=${searchItem?.facility?.id}`,
                                  //   "_self"
                                  // );
                                  router.push(
                                    `${AppRoutes.listingDetail}?${params}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`
                                  );
                                }
                                if (config?.booking_type === `UNIQUE_COUPON`) {
                                  router.push(
                                    `${AppRoutes.benefitDetails}?${params}`
                                  );
                                }
                              } else if (searchType === `OUTLET`) {
                                window.open(
                                  `${
                                    AppRoutes.facilityDetails
                                  }?benefitConfigId=${`${config?._id}`}&${
                                    StringConstants.PARAM_FACILITY_ID
                                  }=${searchItem?.facility?.id}`,
                                  "_self"
                                );

                                // params.set(
                                //   StringConstants.PARAM_FACILITY_ID,
                                //   searchItem?.facility?.id
                                // );
                                // router.push(
                                //   `${AppRoutes.facilityDetails}?${params}`
                                // );
                              }

                              // handleSearchRedirect({
                              //   searchType,
                              //   config,
                              //   searchItem,
                              //   params,
                              //   router,
                              // });

                              // if (searchType === "BENEFIT") {
                              //   const bookingType = config?.booking_type;

                              //   const listingUrl = `${AppRoutes.listingDetail}?benefitConfigId=${config?._id}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`;

                              //   switch (bookingType) {
                              //     case "DELAYED":
                              //     case "CUSTOM_DELAYED":
                              //       console.log("booking-typei", bookingType, searchType);
                              //       router.push(`${AppRoutes.delayedBookingDetails}?${params}`);
                              //       break;

                              //     case "UNIQUE_COUPON":
                              //       router.push(`${AppRoutes.benefitDetails}?${params}`);
                              //       break;

                              //     case "LISTING_V2":
                              //     case "VALET_BOOKING":
                              //     case "QR_BOOKING":
                              //       if (bookingType === "QR_BOOKING") {
                              //         console.log("booking-typep", bookingType, searchType);
                              //       }
                              //       window.open(listingUrl, "_self");
                              //       break;

                              //     default:

                              //       break;
                              //   }

                              // } else if (searchType === "OUTLET") {
                              //   const facilityUrl = `${AppRoutes.facilityDetails}?benefitConfigId=${config?._id}&${StringConstants.PARAM_FACILITY_ID}=${searchItem?.facility?.id}`;
                              //   window.open(facilityUrl, "_self");
                              // }

                              setIsFocused(false);
                            }
                          }}
                          className="c-pointer"
                        >
                          <SearchItemPopular
                            logo={logo}
                            name={name}
                            offerName={offerName}
                            isAvailableQuota={isAvailableQuota}
                            searchOnBehalfOn={config?.header?.searchOnBehalfOn}
                          />
                        </div>
                      );
                    })}
                </div>
              )}

              {searchText?.length == 0 && (
                <>
                  {(config?.header?.isShowDefaultCompaignSection ?? false) && (
                    <div className="search-column-popular">
                      <div className="search-p-heading  font-weight-t-400 mt-3">
                        {t(
                          "header.searchDropdownDefaultCompaignSectionHeading"
                        )}
                      </div>

                      {benefits?.data?.benefit_group_configs
                        ?.filter((e) => {
                          return e.sections?.some((section: any) => {
                            return section?.id == 1;
                          });
                        })
                        .map((searchItem: any, index: any) => {
                          const isAvailableQuota =
                            CommonUtils?.findHaveAvailableQuota(
                              userQuotaData,
                              searchItem?._id
                            );

                          const searchType = config?.header?.searchOnBehalfOn;
                          let logo = `${searchItem?.images?.logo}`;
                          let name = `${searchItem?.name ?? ""}`;
                          let offerName = `${
                            searchItem?.allocation_type_name ?? ""
                          }`;

                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (isAvailableQuota) {
                                  trackEvent(EventLabels.CTA_Redeem, {
                                    screen: "Search",
                                    source: "Search, Search Result",
                                  });
                                  router.push(RedirectToCard(searchItem));
                                  setIsFocused(false);
                                }
                              }}
                              className="c-pointer"
                            >
                              <SearchItemPopular
                                logo={logo}
                                name={name}
                                offerName={offerName}
                                isAvailableQuota={isAvailableQuota}
                                searchOnBehalfOn={searchType}
                              />
                            </div>
                          );
                        })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
